import React, { Component } from 'react'

// ui 
import Button from '../../../components/uielements/button'

// redux
import { connect } from 'react-redux'
import ReportActions from '../../../redux/report/actions'

class FilterHeader extends Component {
    constructor(props){
        super(props)
        this.state = {
            selected: "Existed"
        }
    }

    _handleUpdateSelectButton = (selectStr) => {
        this.props.userChangeHistorySelectStatus(selectStr)
    }

    render(){
        const { status } = this.props
        const classAll = status === "Existed" ? "FilterButtonSelect" : "FilterButton"
        const classSent = status === "Sent" ? "FilterButtonSelect" : "FilterButton"
        const classDraft = status === "Creating" ? "FilterButtonSelect" : "FilterButton"

        return (
            <div className="FilterHeader">
                <Button icon="unordered-list" className={classAll} onClick={() => this._handleUpdateSelectButton("Existed")}>
                    Tất cả
                </Button>
                <Button icon="file-protect" className={classSent} onClick={() => this._handleUpdateSelectButton("Sent")}>
                    Đã gửi
                </Button>
                <Button icon="snippets" className={classDraft} onClick={() => this._handleUpdateSelectButton("Creating")}>
                    Đã lưu nháp
                </Button>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        status: state.qbreport.history_status
    }
}

const mapDispatchToProsp = dispatch => {
    return {
        userChangeHistorySelectStatus: status => {
            dispatch(ReportActions.action.userChangeHistorySelectStatus(status))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProsp)(FilterHeader)